export default __webpack_public_path__ + "static/media/feather_logo.52ad2525.svg";